import React from 'react';

import 'scss/content_download_survey_confirmation.scss';

const ContentDownloadSurveyConfirmation = props => (
    <div className="content-download-survey-confirmation">
        <div className="content-confirmation-img" />
        <div className="content-confirmation-body">
            <div className="confirmation-thank-you">Thank You!</div>
            <div className="confirmation-info">
                Your image should automatically download. If your download does not start
                immediately,&nbsp;
                <a href={props.downloadContentUrl} download={props.fileName}>
                    click here
                </a>
                .
            </div>
        </div>
    </div>
);

export default ContentDownloadSurveyConfirmation;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/content_download_survey_confirmation/index.js